import { debounce } from 'lodash'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useQuery } from 'react-query'
import { useHistory, useLocation, useParams } from 'react-router-dom'

import ConnectorLogView from '@/components/ConnectorLog'
import ErrorConfirmation from '@/components/ErrorConfirmation'
import Page from '@/components/Page'
import { App } from '@/pages/SpaceAppBuilder/utilities/interfaces'
import { fetchConnectorLogsQueryOptions, getFetchAppQueryOptions } from '@/pages/SpaceAppBuilder/utilities/queries'

import messages from './messages'

const SpaceAppBuilderLogsPage = () => {
  const intl = useIntl()

  const history = useHistory()
  const location = useLocation()
  const { spaceId, appId } = useParams<{ spaceId: string; appId: string }>()

  const previousSpaceId = useRef(spaceId)

  const [searchParamsState, setSearchParamsState] = useState({
    spaceId,
    connectorId: appId,
    offset: 0,
    // Default start date to todays date -14 days (retention period)
    start: moment(new Date()).add(-14, 'days').startOf('day').toISOString(),
    end: moment(new Date()).toISOString(),
    correlationId: undefined
  })

  const fetchAppQueryResult = useQuery<App>(getFetchAppQueryOptions({ spaceId, appId }))
  const queryFetchConnectorLogs = useQuery<any>(
    fetchConnectorLogsQueryOptions({
      spaceId: searchParamsState.spaceId,
      connectorId: searchParamsState.connectorId,
      offset: searchParamsState.offset,
      startDate: searchParamsState.start,
      endDate: searchParamsState.end,
      correlationId: searchParamsState.correlationId
    })
  )

  const logs = queryFetchConnectorLogs?.data?.data?.results
  const totalResults = queryFetchConnectorLogs?.data?.data?.totalResults?.value
  const offset = queryFetchConnectorLogs?.data?.data?.offset

  useEffect(() => {
    if (previousSpaceId.current !== spaceId) {
      history.push(`/space/${spaceId}/appbuilder`)
    }
  }, [spaceId, history])

  const searchLogs = debounce(params => {
    const searchParams = { ...searchParamsState, ...params }
    setSearchParamsState(searchParams)
  }, 300)

  const goBack = () => {
    history.push(
      `${location.pathname.slice(0, Math.max(0, location.pathname.lastIndexOf('/appbuilder/')))}/appbuilder/${appId}`
    )
  }

  return (
    <Page>
      <>
        <Page.Header
          title={<FormattedMessage {...messages.title} />}
          backNavTitle={<FormattedMessage {...messages.back} values={{ appName: fetchAppQueryResult?.data?.name }} />}
          goBack={goBack}
        />
        {queryFetchConnectorLogs.isError || fetchAppQueryResult.isError ? (
          <ErrorConfirmation
            error={intl.formatMessage(messages.errorTitle)}
            subMessage={intl.formatMessage(messages.errorMessage)}
          />
        ) : (
          <ConnectorLogView
            offset={offset}
            totalResults={totalResults}
            logs={logs}
            isActionInProgress={queryFetchConnectorLogs.isLoading}
            perPage={10}
            searchLogs={searchLogs}
            searchParams={searchParamsState}
            currentConnector={fetchAppQueryResult?.data || {}}
          />
        )}
      </>
    </Page>
  )
}

export default SpaceAppBuilderLogsPage
